import React from 'react'

import { combineClassnames } from 'app/common/presentation'

import Header, { HeaderProps } from './Header'
import styles from './Table.module.scss'

export interface TableProps<T> extends HeaderProps {
  className?: string
  data: T[]
  renderRow: (item: T, index: number) => React.ReactNode
}

const Table = <T,>({ className, columns, data, renderRow }: TableProps<T>) => (
  <>
    <table className={combineClassnames(styles.table, className)}>
      <Header columns={columns} />
      <tbody>{data.map((item, index) => renderRow(item, index))}</tbody>
    </table>
  </>
)

export default Table
